export const LHR_API = {
  flightSuggest: "/api/heathrow/flights/suggest",
  flightSchedules: "/api/heathrow/flights/schedules",
};

export const flightNumKey = n => String(n || "").replace(/\s+/g, "").toUpperCase();

export const isLikelyFlightNumber = value => /^[A-Z0-9]{2,3}\d{1,4}$/.test(flightNumKey(value));

export const scheduleAnchorTime = s =>
  s?.anchor_time_utc || s?.estimated_time_utc || s?.scheduled_anchor_utc || s?.scheduled_time_utc || null;

export const scheduleDateKey = s => {
  const anchor = scheduleAnchorTime(s);
  if (!anchor) return String(s?.date || s?.snapshot_date || "").slice(0, 10);
  const d = new Date(anchor);
  if (Number.isNaN(d.getTime())) return String(s?.date || s?.snapshot_date || "").slice(0, 10);
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/London",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(d);
  const year = parts.find(p => p.type === "year")?.value;
  const month = parts.find(p => p.type === "month")?.value;
  const day = parts.find(p => p.type === "day")?.value;
  return year && month && day ? `${year}-${month}-${day}` : String(anchor).slice(0, 10);
};

export const dedupeSchedules = (items = [], directionLabel = "Arrival") => {
  const uniq = new Map();
  (Array.isArray(items) ? items : []).forEach(s => {
    const anchor = scheduleAnchorTime(s);
    if (!anchor) return;
    const dateKey = scheduleDateKey(s) || String(anchor).slice(0, 10);
    const key = `${directionLabel}|${dateKey}|${anchor}`;
    if (!uniq.has(key)) uniq.set(key, s);
  });
  return Array.from(uniq.values()).sort(
    (a, b) => new Date(scheduleAnchorTime(a)).getTime() - new Date(scheduleAnchorTime(b)).getTime()
  );
};

export const mapHeathrowSchedulesToBuckets = payload => {
  const rows = Array.isArray(payload?.schedules) ? payload.schedules : [];
  return {
    Arrival: rows.filter(r => String(r?.direction || "").toLowerCase() === "arrival"),
    Departure: rows.filter(r => String(r?.direction || "").toLowerCase() === "departure"),
  };
};

export const formatScheduleLabel = iso => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/London",
  });
};
